import { FC } from "react";
import styles from "./styles.module.scss";

export type TextProps = React.HTMLProps<HTMLDivElement> & {
    variant?:
        | "title"
        | "subtitle"
        | "body"
        | "body-bold"
        | "label_field"
        | "caption";
    children?: React.ReactNode;
    maxLength?: number;
};

const Text: FC<TextProps> = ({
    children,
    variant,
    className,
    maxLength,
    ...rest
}) => {
    let displayText = children;

    if (
        typeof children === "string" &&
        maxLength &&
        children.length > maxLength
    ) {
        displayText = children.slice(0, maxLength) + "...";
    }

    return (
        <div
            {...rest}
            className={`${className ?? ""} ${styles[`${variant}`]}`}
        >
            {displayText}
        </div>
    );
};

export default Text;
